import { EParentRegionActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setParentRegion = actionGenerator<EParentRegionActionType.SetParentRegionId, number>(
  EParentRegionActionType.SetParentRegionId,
);
